const lodash = require("lodash");

const isNumeric = (v) => Number.isFinite(parseFloat(v));
const isBlankOrInvalidNumber = (v) => v == "" || !isNumeric(v);
const isBlankUnit = (v) => {
  const s = v == null ? "" : String(v).trim().toLowerCase();
  return s === "" || s === "null" || s === "undefined";
};

export function effectForUpdatingRestFieldsBasedOnItems(pageStateDummy) {
  let needsUpdate = false;
  let total_weight = 0;
  let total_amount = 0;
  let total_pkgs = 0;
  let updatedPageState = {};

  pageStateDummy["item_in"].forEach((item) => {
    let weight = parseFloat(item.weight);
    let pkgs = parseFloat(item.pkgs);
    let amount = parseFloat(item.amount);

    if (!isNaN(amount)) {
      total_amount += amount;
    }

    if (!isNaN(weight) && !isNaN(pkgs)) {
      total_weight += weight;
    }

    if (!isNaN(pkgs)) {
      total_pkgs += pkgs;
    }
  });

  if (
    process.env.REACT_APP_CLIENT != "xpress" &&
    process.env.REACT_APP_CLIENT != "guru" &&
    process.env.REACT_APP_CLIENT != "g_trans"
  ) {
    const chargeWeight = parseFloat(pageStateDummy["charge_weight"]);
    if (!Number.isFinite(chargeWeight) || total_weight != chargeWeight) {
      updatedPageState["charge_weight"] = String(total_weight);
      needsUpdate = true;
    }
  }

  if (
    process.env.REACT_APP_CLIENT == "guru" ||
    process.env.REACT_APP_CLIENT == "nrab"
  ) {
    const actualWeight = parseFloat(pageStateDummy["actual_weight"]);
    if (!Number.isFinite(actualWeight) || total_weight != actualWeight) {
      updatedPageState["actual_weight"] = String(total_weight);
      needsUpdate = true;
    }
  }

  let roundedFreight = total_amount;

  // Apply rounding only for Arbuda client
  if (process.env.REACT_APP_CLIENT === "arbuda") {
    roundedFreight = Math.ceil(total_amount / 5) * 5;
  }

  const freightVal = parseFloat(pageStateDummy["freight"]);
  if (!Number.isFinite(freightVal) || roundedFreight != freightVal) {
    updatedPageState["freight"] = String(roundedFreight);
    needsUpdate = true;
  }

  const noOfPackage = parseFloat(pageStateDummy["no_of_package"]);
  if (!Number.isFinite(noOfPackage) || total_pkgs != noOfPackage) {
    updatedPageState["no_of_package"] = String(total_pkgs);
    needsUpdate = true;
  }

  return [needsUpdate, updatedPageState];
}

export function effectForUpdatingTotalAmount(pageStateDummy) {
  let needsUpdate = false;
  let freight = pageStateDummy["freight"];
  let hamali = pageStateDummy["hamali"];
  let door_del_charge = pageStateDummy["door_del_charge"];
  let crossing_charge = pageStateDummy["crossing_charge"];
  let bilty_charge = pageStateDummy["bilty_charge"];
  let other_amount = pageStateDummy["other_amount"];
  let lc_charge = pageStateDummy["lc_charge"];
  let total_amount = pageStateDummy["total_amount"];
  let rto = pageStateDummy["rto"]
  let loading_charge = pageStateDummy["loading_charge"]
  let unloading_charge = pageStateDummy["unloading_charge"]
  let advance = pageStateDummy["advance"]
  let detention = pageStateDummy["detention"]
  let pf = pageStateDummy["pf"];
  // let discount = pageStateDummy["discount"] || "0";
  let updatedPageState = {};

  freight = isNumeric(freight) ? parseFloat(freight) : 0;
  hamali = isNumeric(hamali) ? parseFloat(hamali) : 0;
  lc_charge = isNumeric(lc_charge) ? parseFloat(lc_charge) : 0;
  door_del_charge = isNumeric(door_del_charge)
    ? parseFloat(door_del_charge)
    : 0;
  crossing_charge = isNumeric(crossing_charge)
    ? parseFloat(crossing_charge)
    : 0;
  bilty_charge = isNumeric(bilty_charge) ? parseFloat(bilty_charge) : 0;
  other_amount = isNumeric(other_amount) ? parseFloat(other_amount) : 0;
  pf = isNumeric(pf) ? parseFloat(pf) : 0;
  rto = isNumeric(rto) ? parseFloat(rto) : 0;
  loading_charge = isNumeric(loading_charge) ? parseFloat(loading_charge) : 0;
  unloading_charge = isNumeric(unloading_charge)
    ? parseFloat(unloading_charge)
    : 0;
  advance = isNumeric(advance) ? parseFloat(advance) : 0;
  detention = isNumeric(detention) ? parseFloat(detention) : 0;
  total_amount = isNumeric(total_amount) ? parseFloat(total_amount) : 0;

  let calculatedTotalAmount = 0;

  if(pageStateDummy.is_crossing == "N"){
    if(process.env.REACT_APP_CLIENT == "gdala_log") {
      calculatedTotalAmount = Math.round(freight + hamali + door_del_charge + bilty_charge + other_amount + lc_charge);
    }
    else if(process.env.REACT_APP_CLIENT == "xpress"){
      calculatedTotalAmount = Math.round(freight + hamali + detention + loading_charge + unloading_charge + rto - advance);
    }
    else {
      if(process.env.REACT_APP_CLIENT == "xpress"){
        calculatedTotalAmount = Math.round(freight + hamali + detention + rto - advance);
      }
      else if (process.env.REACT_APP_CLIENT != "xpress") {
        calculatedTotalAmount =
          freight +
          hamali +
          // door_del_charge +
          bilty_charge +
          other_amount +
          lc_charge;

        if (process.env.REACT_APP_CLIENT !== "bvtc") {
          calculatedTotalAmount += door_del_charge;
        }

        if (process.env.REACT_APP_CLIENT === "bbac") {
          calculatedTotalAmount += crossing_charge;
        }

        if (process.env.REACT_APP_CLIENT === "bgtc") {
          calculatedTotalAmount += pf;
        }
      }
    }
  }
  else {
    calculatedTotalAmount = freight + hamali + other_amount + lc_charge;

    if (process.env.REACT_APP_CLIENT !== "bvtc") {
      calculatedTotalAmount += door_del_charge;
    }

    if (process.env.REACT_APP_CLIENT === "bbac") {
      calculatedTotalAmount += crossing_charge;
    }

    if (process.env.REACT_APP_CLIENT === "bvtc") {
      calculatedTotalAmount += pf;
    }
  }

  // if (process.env.REACT_APP_CLIENT === "guru") {
  //   let discountPercentage = 0;
    
  //   if (discount === "1") {
  //     discountPercentage = 25;
  //   } else if (discount === "2") {
  //     discountPercentage = 50;
  //   } else {
  //     discountPercentage = 0;
  //   }

  //   if (discountPercentage > 0) {
  //     calculatedTotalAmount = calculatedTotalAmount - (calculatedTotalAmount * discountPercentage) / 100;
  //   }

  //   calculatedTotalAmount = Math.round(calculatedTotalAmount * 100) / 100;
  // }

  const tolerance = 0.01;
  if (Math.abs(calculatedTotalAmount - total_amount) > tolerance) {
    updatedPageState["total_amount"] = String(calculatedTotalAmount);
    needsUpdate = true;
  }

  return [needsUpdate, updatedPageState];
}

export function effectForRowWiseAmount(pageStateDummy) {
  let newItems = [];
  let needsUpdate = false;
  let updatedPageState = {};
  pageStateDummy.item_in.forEach((item) => {
    if (item == null) {
      return;
    }
    let newItem = {};
    if (isBlankUnit(item.unit)) {
      newItems.push(item);
      return;
    } else if (item.unit == "w" || item.unit == "W") {
      if (
        isBlankOrInvalidNumber(item.weight) ||
        isBlankOrInvalidNumber(item.rate) ||
        isBlankOrInvalidNumber(item.pkgs)
      ) {
        newItems.push(item);
        return;
      }
      let weight = parseFloat(item.weight);
      let rate = parseFloat(item.rate);
      let amount = isNumeric(item.amount) ? parseFloat(item.amount) : null;
      let calculatedAmount = (weight * rate).toFixed(2);
      if (amount === null || amount != calculatedAmount) {
        needsUpdate = true;
        newItem = item;
        newItem.amount = calculatedAmount;
        newItems.push(newItem);
      } else {
        newItems.push(item);
      }
    } else if (item.unit == "c" || item.unit == "C") {
      if (
        isBlankOrInvalidNumber(item.pkgs) ||
        isBlankOrInvalidNumber(item.rate)
      ) {
        newItems.push(item);
        return;
      }
      let pkgs = parseFloat(item.pkgs);
      let rate = parseFloat(item.rate);
      let amount = isNumeric(item.amount) ? parseFloat(item.amount) : null;
      let calculatedAmount = String(pkgs * rate);
      if (amount === null || amount != pkgs * rate) {
        needsUpdate = true;
        newItem = item;
        newItem.amount = calculatedAmount;
        newItems.push(newItem);
      } else {
        newItems.push(item);
      }
    } else if (
      item.unit == "f" ||
      item.unit == "F" ||
      item.unit == "t" ||
      item.unit == "T"
    ) {
      if (isBlankOrInvalidNumber(item.rate)) {
        newItems.push(item);
        return;
      }
      let rate = parseFloat(item.rate);
      let amount = isNumeric(item.amount) ? parseFloat(item.amount) : null;
      if (amount === null || amount != rate) {
        needsUpdate = true;
        newItem = item;
        newItem.amount = String(rate);
        newItems.push(newItem);
      } else {
        newItems.push(item);
      }
    } else {
      newItems.push(item);
    }
  });
  if (needsUpdate) {
    updatedPageState = { item_in: newItems };
    return [needsUpdate, updatedPageState];
  } else {
    return [needsUpdate, {}];
  }
}

export function biltyAutoUpdationEffectsDummy(pageStateDummy) {
  let updatedPageState = {};
  let updatedPageStateTotal = {};
  let needsUpdate = false;
  let tempNeedsUpdate = false;
  [tempNeedsUpdate, updatedPageState] = effectForRowWiseAmount(pageStateDummy);
  pageStateDummy = { ...pageStateDummy, ...updatedPageState };
  updatedPageStateTotal = { ...updatedPageStateTotal, ...updatedPageState };
  if (tempNeedsUpdate) {
    needsUpdate = true;
  }
  [tempNeedsUpdate, updatedPageState] = effectForUpdatingRestFieldsBasedOnItems(
    { ...pageStateDummy }
  );
  pageStateDummy = { ...pageStateDummy, ...updatedPageState };
  updatedPageStateTotal = { ...updatedPageStateTotal, ...updatedPageState };
  if (tempNeedsUpdate) {
    needsUpdate = true;
  }

  [tempNeedsUpdate, updatedPageState] = effectForUpdatingTotalAmount({
    ...pageStateDummy,
  });
  pageStateDummy = { ...pageStateDummy, ...updatedPageState };
  updatedPageStateTotal = { ...updatedPageStateTotal, ...updatedPageState };
  if (tempNeedsUpdate) {
    needsUpdate = true;
  }

  if (needsUpdate) {
    return [needsUpdate, updatedPageStateTotal];
  } else {
    return [needsUpdate, {}];
  }
}

export function isBvtcBigChecked(value) {
  if (value === 1 || value === true) {
    return true;
  }
  if (value === 0 || value === false || value == null) {
    return false;
  }
  const normalized = String(value).trim().toUpperCase();
  return normalized === "BIG" || normalized === "1" || normalized === "TRUE";
}

function renameTruckSizeKeyForRow(item) {
  if (!item || !("truck_size" in item)) {
    return item;
  }
  const bigFlag = isBvtcBigChecked(item.truck_size) ? 1 : 0;
  const renamed = {
    ...item,
    big: bigFlag,
    is_big: bigFlag,
    truck_size: "null",
  };
  return renamed;
}

export function renameTruckSizeRowsToBig(itemInArray) {
  if (
    process.env.REACT_APP_CLIENT !== "bvtc" ||
    !Array.isArray(itemInArray)
  ) {
    return itemInArray;
  }
  return itemInArray.map(renameTruckSizeKeyForRow);
}

export function nullifyTruckSizeRowsForBvtcPrint(itemInArray) {
  if (
    process.env.REACT_APP_CLIENT !== "bvtc" ||
    !Array.isArray(itemInArray)
  ) {
    return itemInArray;
  }
  return itemInArray.map((row) =>
    row && "truck_size" in row ? { ...row, truck_size: null } : row
  );
}

export function mapBvtcBigToTruckSize(itemInfoArray) {
  if (
    process.env.REACT_APP_CLIENT !== "bvtc" ||
    !Array.isArray(itemInfoArray)
  ) {
    return itemInfoArray;
  }
  return itemInfoArray.map((item) => {
    if (!item || (!("big" in item) && !("is_big" in item))) {
      return item;
    }
    const bigValue = "big" in item ? item.big : item.is_big;
    const mapped = {
      ...item,
      truck_size: isBvtcBigChecked(bigValue) ? "BIG" : "",
    };
    delete mapped.big;
    delete mapped.is_big;
    return mapped;
  });
}

export function additionalFilterOnInputForBilty(inputObject,methodType) {
    // let biltyDate = new Date(inputObject.bilty_date);


    var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    var localISOTime = (new Date(new Date(inputObject.bilty_date ?? new Date()).getTime() - tzoffset)).toISOString().slice(0, -1);

    inputObject.bilty_date = localISOTime;

    // let tmpDate = new Date(biltyDate).toLocaleString('sv');
  
  if(process.env.REACT_APP_CLIENT == "shubham" || process.env.REACT_APP_CLIENT == "nptc" || process.env.REACT_APP_CLIENT == "nrab" || process.env.REACT_APP_CLIENT == "sra") {
    if(inputObject.destination == "" && inputObject.destination_name == "") {
      inputObject.destination = inputObject.station_to
      inputObject.destination_name = inputObject.station_to_name
    }
    else if(inputObject.destination && inputObject.destination_name) {
      inputObject.destination = inputObject.station_to
      inputObject.destination_name = inputObject.station_to_name
    }
  }

  if (process.env.REACT_APP_CLIENT === "bvtc") {
    // if (!inputObject.station_to && !inputObject.station_to_name) {
    //   inputObject.station_to = inputObject.destination;
    //   inputObject.station_to_name = inputObject.destination_name;
    // }

    if (!inputObject.billing_party && !inputObject.billing_party_name) {
      inputObject.billing_party = inputObject.consignor_id;
      inputObject.billing_party_name = inputObject.consignor_name;
    }
  }

  if(process.env.REACT_APP_CLIENT == "vihira" || process.env.REACT_APP_CLIENT == "nrab") {
    if(inputObject.billing_party == "" && inputObject.billing_party_name == "") {
      inputObject.billing_party_name = inputObject.consignor_name
      inputObject.billing_party = inputObject.consignor_id
    }
    else if(inputObject.billing_party && inputObject.billing_party_name) {
      inputObject.billing_party_name = inputObject.consignor_name
      inputObject.billing_party = inputObject.consignor_id
    }
  }

  if(process.env.REACT_APP_CLIENT == "guru") {
    if(inputObject.pf == "") {
      inputObject.pf = "0";
    }
  }

  if(process.env.REACT_APP_CLIENT == "nrab") {
    if(inputObject.add == "") {
      inputObject.add = "0";
    }
    if(inputObject.charge_weight == "") {
      inputObject.charge_weight = "0";
    }
    else if(inputObject.charge_weight) {
      inputObject.charge_weight = "0";
    }
  }

  if ("item_in" in inputObject) {
    inputObject.item_in = inputObject.item_in.map((item) => ({
      ...item,
      weight: item.weight ? parseFloat(item.weight) : 0,
    }));
    inputObject.item_in = renameTruckSizeRowsToBig(inputObject.item_in);
  }

  if (
    inputObject.eway_bill_info &&
    inputObject.eway_bill_info.length == 1 &&
    inputObject.eway_bill_info[0].eway_bill_no == ""
  ) {
    delete inputObject.eway_bill_info;
  }

  if (inputObject.actual_weight == "" || inputObject.actual_weight == null) {
  
    const clientsUsingChargeWeight = ["avr", "std", "bgtc", "nptc", "nrab", "arbuda", "bbac", "jtsa", "bvtc"];

    if (clientsUsingChargeWeight.includes(process.env.REACT_APP_CLIENT)) {
      inputObject.actual_weight = inputObject.charge_weight;
    } else {
      inputObject.actual_weight = "0";
    }
  }
  
  if (inputObject.actual_weight == "") { 
    inputObject.actual_weight = "0"; 
  }

  if (
    inputObject.consignor_gst == "N.A" ||
    inputObject.consignor_gst == "n.a"
  ) {
    inputObject.consignor_gst = null;
  }
  if (
    inputObject.consignee_gst == "N.A" ||
    inputObject.consignee_gst == "n.a"
  ) {
    inputObject.consignee_gst = null;
  }

  let dummyObject = lodash.cloneDeep(inputObject);

  if (dummyObject.is_crossing == "N" || dummyObject.is_crossing == "n") {
    dummyObject.transporter_id = null;
    dummyObject.transporter_name = null;
    // dummyObject.suffix = null;
  }
  delete dummyObject.is_crossing;

  // Removing entries with blank string.
  for (let key in dummyObject) {
    if(process.env.REACT_APP_CLIENT == "gdala_log"){
      if (dummyObject[key] == "" && key != "no_of_package") {
        dummyObject[key] = null;
      }
    }
    else {
      if (key !== "charge_weight" && dummyObject[key] == "") {
        dummyObject[key] = null;
      }
    }
  }

  // Removing new row from tables
  if ("item_in" in dummyObject) {
    for (let i = 0; i < dummyObject.item_in.length; i++) {
      delete dummyObject.item_in[i].new_row;
    }
  }
  if ("eway_bill_info" in dummyObject && dummyObject.eway_bill_info != null) {
    for (let i = 0; i < dummyObject.eway_bill_info.length; i++) {
      delete dummyObject.eway_bill_info[i].new_row;
    }
  }
  if(!dummyObject.suffix) {
      dummyObject.suffix = "null";
  }

  if(process.env.REACT_APP_CLIENT == "gdala_log") {
    if (methodType === "POST") {
      dummyObject.bilty_no = null;
    }
  }
//   if(dummyObject.suffix)
  return dummyObject;
}

export function additionalFilterOnResponseForGetEwb(inputObject) {
  return inputObject.eway_bill_info[0];
}
